// import { Widget } from "@uploadcare/react-widget";
import { FileUploaderRegular } from "@uploadcare/react-uploader";
import EmojiPicker from "emoji-picker-react";
import { useContext, useEffect, useState } from "react";
import { IData } from "./type";
import toast from "react-hot-toast";
import { NavbarContext } from "./context";
import Swal from "sweetalert2";
import api from "./api";

export default function LogoSection() {
  const [data, setData] = useState({
    logo_type: "image",
    logo_image: "",
    logo_text: "",
    logo_emoji: "",
    logo_size: 20,
    height: 20,
    is_floating: false,
    background_color: "",
    color: "",
  } as IData);

  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [loading, setLoading] = useState(false);
  const [removeLoading, setRemoveLoading] = useState(false);

  const { save, logoData, siteId } = useContext(NavbarContext);

  const remove = async () => {
    return await api.remove(siteId);
  };

  const removeNavbar = async () => {
    Swal.fire({
      title: "Remove navbar",
      text: "Are you sure you want to remove this navbar?",
      showDenyButton: true,
      confirmButtonText: "Continue",
      denyButtonText: "Cancel",
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        toast
          .promise(remove(), {
            loading: "Deleting link...",
            success: "Link deleted",
            error: "Error deleting link",
          })
          .then(() => {
            window.location.reload();
          });
      }
    });
  };

  useEffect(() => {
    window.addEventListener("click", (e) => {
      if (
        e.target instanceof HTMLElement &&
        !e.target.closest(".emoji-picker-react")
      ) {
        setShowEmojiPicker(false);
      }
    });
  }, []);

  useEffect(() => {
    setData(logoData);
  }, [logoData]);

  const update = () => {
    setLoading(true);
    toast.promise(
      save({
        logo_type: data.logo_type,
        logo_image: data.logo_image,
        logo_text: data.logo_text,
        logo_emoji: data.logo_emoji,
        logo_size: Number(data.logo_size || "40"),
        height: isNaN(Number(data.height || "40"))
          ? 40
          : Number(data.height || "40"),
        is_floating: data.is_floating,
        background_color: data.background_color,
        color: data.color,
      }),
      {
        loading: "Saving...",
        success: (res) => {
          setLoading(false);
          return "Saved!";
        },
        error: (err) => {
          setLoading(false);
          return "Error saving";
        },
      }
    );
  };

  return (
    <div class="navbarfooter-half-wrapper right-side">
      <div class="section-mb-40">
        <h4>Logo</h4>
        <div class="form-block-100 ">
          <form
            id="email-form-2"
            name="email-form-2"
            data-name="Email Form 2"
            method="get"
            data-wf-page-id="60e84ecd7a80ead60d99f12b"
            data-wf-element-id="84a563b8-2261-b4b5-759a-6a06e9e67788"
            aria-label="Email Form 2"
          >
            <label for="">Set as a logo:</label>
            <div
              class="relative-div-wrapper-for-tooltips _100-width mt-5"
              style={{
                zIndex: 10,
              }}
            >
              <select
                id="appearance-2"
                name="appearance-2"
                data-name="Appearance 2"
                class="form-entry-select-dropdown _100-width w-select"
                defaultValue={data.logo_type}
                onChange={(e: any) => {
                  setData({
                    ...data,
                    logo_type: e.target.value,
                  });
                }}
              >
                <option value="image">Image</option>
                <option value="emoji">Emoji</option>
                <option value="text">Text</option>
                <option value="no-logo">No logo</option>
              </select>
            </div>

            {data.logo_type === "image" && (
              <div class="mt-30">
                <label for="email" class="label-step">
                  Set an image logo
                </label>
                <div class="div-block-264">
                  {/* @ts-ignore */}
                  {/*<Widget*/}
                  {/*  publicKey="f1b2cf809355c191dc72"*/}
                  {/*  imagesOnly*/}
                  {/*  onChange={(e) => {*/}
                  {/*    setData({*/}
                  {/*      ...data,*/}
                  {/*      logo_image: e.cdnUrl,*/}
                  {/*    });*/}
                  {/*  }}*/}
                  {/*/>*/}
                  <FileUploaderRegular
                      classNameUploader="uc-dark"
                      className="fileUploaderWrapper"
                      pubkey="31bbea05082a5fbd5967"
                      multiple={false} // disable multiple file uploads
                      accept="image/*" // accept only image files
                      onChange={(e) => {
                        setData({
                          ...data,
                          logo_image: e.allEntries[0]?.cdnUrl,
                        });
                      }}

                  />
                </div>

                {data.logo_image && (
                  <img
                    src={data.logo_image}
                    style={{
                      height: "30px",
                      marginTop: "20px",
                      display: "block",
                    }}
                  />
                )}
              </div>
            )}
            {data.logo_type === "emoji" && (
              <div class="mt-30">
                <label for="email" class="label-step">
                  Set an emoji logo
                </label>
                <button
                  class="w-button button-3"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setShowEmojiPicker(true);
                  }}
                >
                  Select emoji
                </button>
                {showEmojiPicker && (
                  <>
                    <div
                      class="div-block-264"
                      style={{
                        position: "relative",
                      }}
                    >
                      <div
                        style={{
                          position: "absolute",
                          zIndex: 100,
                        }}
                      >
                        {/* @ts-ignore */}
                        <EmojiPicker
                          onEmojiClick={(e, emojiObject) => {
                            console.log((emojiObject.target as any).currentSrc);

                            setData({
                              ...data,
                              logo_emoji: (emojiObject.target as any)
                                .currentSrc,
                            });
                          }}
                        />
                      </div>
                    </div>
                    <div
                      style={{
                        position: "absolute",
                        top: 0,
                        left: "0px",
                        width: "100vw",
                        height: "100vh",
                        zIndex: 10,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    ></div>
                  </>
                )}

                {data.logo_emoji && (
                  <img
                    src={data.logo_emoji}
                    style={{
                      height: "30px",
                      marginTop: "20px",
                      display: "block",
                    }}
                  />
                )}
              </div>
            )}
            {data.logo_type === "text" && (
              <div class="mt-30">
                <div class="label-step">
                  Set a title logo
                  <br />
                </div>
                <input
                  type="text"
                  class="form-entry form-field w-input"
                  placeholder="Title"
                  value={data.logo_text}
                  onChange={(e: any) => {
                    setData({
                      ...data,
                      logo_text: e.target.value,
                    });
                  }}
                />
              </div>
            )}
            <div class="button-white-with-shadow pt-pb-0 mt-30">
              <div class="slider-wrapper">
                <div class="flex-horizontal-top-left mt-14">
                  <div class="flex-horizontal-center-extremes _100-width mb-10">
                    <div>Logo height</div>
                    <div>{data.logo_size} pixels</div>
                  </div>
                </div>
                <div class="fs-rangeslider_wrapper">
                  <input
                    type="range"
                    min="20"
                    max="300"
                    style={{ width: "100%" }}
                    value={data.logo_size}
                    onChange={(e: any) => {
                      setData({
                        ...data,
                        logo_size: Number(e.target.value),
                      });
                    }}
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="section-mb-40">
        <h4>Navbar styling</h4>
        <div class="form-block-100 ">
          <form
            id="email-form-3"
            name="email-form-3"
            data-name="Email Form 3"
            method="get"
            data-wf-page-id="60e84ecd7a80ead60d99f12b"
            data-wf-element-id="84a563b8-2261-b4b5-759a-6a06e9e677b5"
            aria-label="Email Form 3"
          >
            <div class="button-white-with-shadow pt-pb-0">
              <div class="slider-wrapper">
                <div class="flex-horizontal-top-left mt-14">
                  <div class="flex-horizontal-center-extremes _100-width mb-10">
                    <div>Navbar size</div>
                    <div>{data.height} pixels</div>
                  </div>
                </div>
                <div class="fs-rangeslider_wrapper">
                  <div class="fs-rangeslider_wrapper">
                    <input
                      type="range"
                      min="20"
                      max="300"
                      style={{ width: "100%" }}
                      defaultValue={String(data.height)}
                      onChange={(e: any) => {
                        setData({
                          ...data,
                          height: e.target.value,
                        });
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="flex-horizontal-center-extremes-100 mt-10">
              <label class="w-checkbox dropdown-entry aligned-horizontally-relative">
                <input
                  type="checkbox"
                  class="w-checkbox-input checkbox-2"
                  id="navbar_visible_on_scroll"
                  checked={data.is_floating}
                  onChange={(e: any) => {
                    setData({
                      ...data,
                      is_floating: e.target.checked,
                    });
                  }}
                />
                <span
                  class="form-entry-w-o-size-constraints-copy w-form-label"
                  for="navbar_visible_on_scroll"
                ></span>
                <div class="text-block-12">
                  Make the navigation bar visible on scroll
                </div>
              </label>
            </div>
            <div class="flex-horizontal-center-extremes-100 mt-10">
              <label class="w-checkbox dropdown-entry aligned-horizontally-relative">
                <input
                  type="checkbox"
                  id="background_colour"
                  class="w-checkbox-input checkbox-2"
                  defaultChecked={!!data.background_color}
                  onChange={(e: any) => {
                    setData({
                      ...data,
                      background_color: e.target.checked ? "black" : "",
                    });
                  }}
                />
                <span
                  class="form-entry-w-o-size-constraints-copy w-form-label"
                  for="background_colour"
                ></span>
                <div class="text-block-12">Background colour</div>
              </label>
            </div>
            {data.background_color && (
              <div class="flex-horizontal-center-extremes-100 mt-10">
                <input
                  type="color"
                  class="form-entry-w-o-size-constraints w-input"
                  placeholder="#ffffff"
                  style={{
                    width: "100%",
                    padding: "0px",
                  }}
                  defaultValue={data.background_color}
                  onChange={(e: any) => {
                    setData({
                      ...data,
                      background_color: e.target.value,
                    });
                  }}
                />
              </div>
            )}

            <div class="flex-horizontal-center-extremes-100 mt-10">
              <label class="w-checkbox dropdown-entry aligned-horizontally-relative">
                <input
                  type="checkbox"
                  id="text_colour"
                  class="w-checkbox-input checkbox-2"
                  defaultChecked={!!data.color}
                  onChange={(e: any) => {
                    setData({
                      ...data,
                      color: e.target.checked ? "black" : "",
                    });
                  }}
                />
                <span
                  class="form-entry-w-o-size-constraints-copy w-form-label"
                  for="text_colour"
                ></span>
                <div class="text-block-12">Text colour</div>
              </label>
            </div>

            {data.color && (
              <div class="flex-horizontal-center-extremes-100 mt-10">
                <input
                  type="color"
                  class="form-entry-w-o-size-constraints w-input"
                  placeholder="#ffffff"
                  defaultValue={data.color}
                  style={{
                    width: "100%",
                    padding: "0px",
                  }}
                  onChange={(e: any) => {
                    setData({
                      ...data,
                      color: e.target.value,
                    });
                  }}
                />
              </div>
            )}

            <div
              class="dropdown-entry"
              style={{
                padding: "10px 0px",
              }}
            >
              {!loading ? (
                <p
                  class="button button-blue-primary button-block-centered-text mt-0 w-button"
                  onClick={(e) => {
                    e.preventDefault();
                    update();
                  }}
                >
                  Save changes
                </p>
              ) : (
                <div class="button button-blue-primary button-block-centered-text mt-0 w-button">
                  Saving...
                </div>
              )}
            </div>

            {logoData.id && (
              <div
                style={{
                  width: "100%",
                  marginTop: "10px",
                }}
              >
                {!removeLoading ? (
                  <div
                    onClick={removeNavbar}
                    class="button button-blue-primary button-block-centered-text mt-0 w-button"
                    style={{
                      backgroundColor: "red",
                    }}
                  >
                    Remove Navbar
                  </div>
                ) : (
                  <div class="button button-blue-primary button-block-centered-text mt-0 w-button">
                    Saving...
                  </div>
                )}
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
}
